import { AvatarTTSInputProps } from './AvatarTTSInputProps'

export abstract class AvatarVoiceServices {
  abstract warmUp(): void
  abstract init(
    audioContext?: AudioContext,
    audioElement?: HTMLAudioElement
  ): void
  abstract getIsWarmUpRequired(): boolean
  abstract getAudioElement(): HTMLAudioElement
  abstract getAudioContext(): AudioContext
  abstract getAudioAnalyser(): AnalyserNode
  abstract setAudioSourceNode(
    audioContext?: AudioContext,
    sourceNode?: AudioNode
  ): void
  abstract setAnalyser(audioContext?: AudioContext): void
  abstract cleanup(): void
}

export class AvatarVoiceService extends AvatarVoiceServices {
  playAudioFromNode(
    audioNode: AudioNode,
    audioContext: AudioContext,
    handleAudioPlay?: boolean
  ): void {
    if (!this.audio) this.audio = new Audio()

    if (audioContext.state === 'suspended') {
      audioContext.resume()
    }

    if (!this.analyser) this.analyser = audioContext.createAnalyser()

    audioNode.connect(this.analyser!)
    if (handleAudioPlay) return
    audioNode.connect(audioContext.destination)
    ;(audioNode as AudioBufferSourceNode).start()
  }

  playAudioFromSource(audioSrc: string, audioContext: AudioContext): void {
    if (!this.audio) this.audio = new Audio()

    if (audioContext.state === 'suspended') {
      audioContext.resume()
    }

    if (!this.analyser) this.analyser = audioContext.createAnalyser()

    if (!this.sourceNode) {
      this.sourceNode = audioContext.createMediaElementSource(this.audio)
    }

    this.sourceNode.connect(this.analyser!)
    this.sourceNode.connect(audioContext.destination)
    this.audio.crossOrigin = 'anonymous'
    this.audio.src = audioSrc
    this.audio.play()
  }

  connectAudioElement(
    element: HTMLAudioElement,
    audioContext: AudioContext
  ): void {
    if (this.audio)
      throw new Error(
        'you cannot connect a new audio element after played audio from source or node!'
      )
    this.audio = element

    if (audioContext.state === 'suspended') {
      audioContext.resume()
    }

    if (!this.analyser) this.analyser = audioContext.createAnalyser()

    if (!this.sourceNode) {
      this.sourceNode = audioContext.createMediaElementSource(this.audio)
    }
    this.sourceNode.connect(this.analyser!)
    this.sourceNode.connect(audioContext.destination)
  }

  setAnalyser(audioContext?: AudioContext): void {
    this.analyser = audioContext?.createAnalyser()
  }

  setAudioSourceNode(
    audioContext?: AudioContext,
    sourceNode?: AudioNode
  ): void {
    if (!audioContext || !sourceNode || !this.analyser) return
    this.audioContext = audioContext
    sourceNode.connect(this.analyser)
  }

  warmUp(): void {}

  getIsWarmUpRequired(): boolean {
    return false
  }

  audioContext?: AudioContext
  analyser?: AnalyserNode
  audio?: HTMLAudioElement

  externalAudioContext?: AudioContext

  sourceNode?: AudioNode | undefined

  audioPlaying: boolean | undefined

  init(audioContext: AudioContext, audioElement: HTMLAudioElement): void {}

  getAudioElement(): HTMLAudioElement {
    return this.audio!
  }

  getAudioContext(): AudioContext {
    if (!this.audioContext)
      this.audioContext = new (window.AudioContext ||
        // @ts-ignore
        window.webkitAudioContext)()
    return this.audioContext
  }

  setAudioContext(audioContext: AudioContext): void {
    if (!this.audioContext) this.audioContext = audioContext
  }

  getAudioAnalyser(): AnalyserNode {
    return this.analyser!
  }

  cleanup(): void {
    this.analyser?.disconnect()
    this.sourceNode?.disconnect()
    if (this.audio) {
      this.audio.remove()
    }
    this.audioContext?.close()

    this.audio = undefined
    this.audioContext = undefined
    this.analyser = undefined
    this.sourceNode = undefined
  }
}
